import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class ThemeRevealableElement {

    constructor(dom) {

        // Vars
        // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
        this.NAME = `ThemeRevealableElement`;

        this.dom = dom;

        this.isRevealed = false;
        this.isRevealedDataAttribute = `data-theme-revealable-element`;
        this.isRevealedDataAttributeValue = `revealed`;
    }

    // Logic
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
    init() {
        Logger.info(`${this.NAME} > init`);

        const self = this;

        /**
        * Initialize the Vimeo Player when visible
        */
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const intersecting = entry.isIntersecting;
                if (intersecting && !this.isRevealed) {
                    self.reveal();
                }
            })
        })

        observer.observe(this.dom);

    }

    reveal() {
        Logger.info(`${this.NAME} > reveal`);
        this.dom.setAttribute(this.isRevealedDataAttribute, this.isRevealedDataAttributeValue);
        this.isRevealed = true;
    }
}

// Mixins
Object.assign(ThemeRevealableElement.prototype, eventMixin);
